
/* 我要开发票 */
<template>
  <div>
    <z-dialog :title="title" v-model="display" @close="closeDialog" @submit="submit">
      <div :class="preflxCls">
        <Form
          ref="invoicelogFrom"
          :model="invoiceFrom"
          :rules="ruleInInvoice"
          :label-width="110"
          label-position="left"
        >
          <FormItem label="发票类型：" prop="invoiceType">
            <Row class="invoice-type" :gutter="15" type="flex" justify="center" align="middle">
              <Col span="12">
                <Button
                  long
                  :type="invoiceFrom.invoiceType === 1 ? 'primary' : 'default'"
                  @click="invoiceFrom.invoiceType = 1"
                >增值税专用发票</Button>
              </Col>
              <Col span="12">
                <Button
                  long
                  :type="invoiceFrom.invoiceType === 2 ? 'primary' : 'default'"
                  @click="invoiceFrom.invoiceType = 2"
                >纸质普通发票</Button>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="发票类型：" prop="commomType" v-if="invoiceFrom.invoiceType === 2">
            <Row class="invoice-type" :gutter="15" type="flex" justify="center" align="middle">
              <Col span="12">
                <Button
                  long
                  :type="invoiceFrom.commomType === 1 ? 'primary' : 'default'"
                  @click="invoiceFrom.commomType = 1"
                >个人</Button>
              </Col>
              <Col span="12">
                <Button
                  long
                  :type="invoiceFrom.commomType === 2 ? 'primary' : 'default'"
                  @click="invoiceFrom.commomType = 2"
                >单位</Button>
              </Col>
            </Row>
          </FormItem>
        </Form>

        <invoice-purpose :optionsSelect="selectInv" :price="price" :companyInfo="companyDetail" :ossUrl="ossUrl" :ossKeys="ossKeys" :choicedAddress="choicedAddress" :invoiceFrom="invoiceFrom"></invoice-purpose>
      </div>
    </z-dialog>
    <z-addresslog
      title="选择地址"
      :lists="addressLists"
      :total="addreessTotal"
      :display="model"
      cel
      width="800"
      @changePage="changePageHandle"
      @close="closeModel"
      @submitAddress="submitAddressHandle"
    ></z-addresslog>
  </div>
</template>
<script>
const preflxCls = "zInvoicelog";
import { findComponentDownward } from "../../utils/assist.js";
import invoicePurpose from "./common/invoice-purpose";
import emitter from "../../mixins/emitter.js";
import ZAddresslog from "./addresslog.vue";
import _ from "lodash";
export default {
  name: "ZInvoicelog",
  mixins:[ emitter ],
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      diaologDom: null,
      model: false,
      invoiceFrom: {
        invoiceType: 1, // 总发票类型
        commomType: 1 //普通发票类型
      },
      ruleInInvoice: {
        invoiceType: [{ required: true, message: "请选择发票类型" }],
        commomType: [{ required: true, message: "请选择发票类型" }]
      },
      choicedAddress: {}
    };
  },
  components: { invoicePurpose, ZAddresslog },
  props: {
    selectInv: {
      // 传递的搜索发票公司名称
      type: Array,
      default: function() {
        return [];
      }
    },
    companyDetail: {
      // 传递的公司详细信息
      type: Object,
      default: function() {
        return {};
      }
    },
    // 现有地址列表
    addressLists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    addreessTotal: {
        type:Number,
        default: 0
    },
    /* 发票价格 */
    price:{
      type: [Number,String],
      default: ''
    },
    ossKeys: {
      type: Object,
      default: function() {
        return {};
      }
    },
    ossUrl: {
      type: String,
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "暂无标题"
    },
    width: {
      type: [Number, String],
      default: 360
    },
    // button text
    btnTxt: {
      type: [Number, String],
      default: "确定"
    },
    // 是否是长按钮
    long: {
      type: Boolean,
      default: false
    },
    // 是否需要取消
    cel: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: "zhulogicModule"
    }
  },
  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  },
  methods: {
    closeModel() {
      this.model = false;
    },
    // 选择地址确定提交
    submitAddressHandle(params) {
        this.choicedAddress = params;
        this.model = false;
    },
    closeDialog() {
      this.$emit("close");
      this.cencelInvoice();
    },
    // 确定提交 发票信息
    submit() {
      this.broadcast('InvoicePurpose', 'submitInvoice')
    },

    // 取消
    cencelInvoice() {
      this.broadcast('InvoicePurpose', 'cencelInvoiceHandle')
    },

    /* 地址分页选项 */
    changePageHandle(filter) {
      this.$emit('changePageInvoice', filter)
    }
  },
  created() {
    // 搜索税务公司信息
    this.$on("selectHandle", query => {
      this.$emit("searchInvioce", query);
    });
    // 选择公司
    this.$on("changeInvoice", value => {
      this.$emit("changeCompany", value);
    });
    // 选择地址列表
    this.$on("chiocedAddress", () => {
        this.model = true;
    });

    // 填写完成 submit putout
    this.$on('submitInsert', (invioce_data) => {
      if(!invioce_data) return false;
      this.$emit('submit', invioce_data)
    })
  }
};
</script>
